function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  
  const overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage, image);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image, originalImage) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  
  container.style.position = 'absolute'; // ✅ Ensure it overlays the image
  container.style.top = '0';
  container.style.left = '0';
  container.style.width = `${originalImage.clientWidth}px`;  // ✅ Match image size
  container.style.height = `${originalImage.clientHeight}px`;
  container.style.backgroundSize = `${originalImage.clientWidth * 2}px`; // ✅ Adjust zoom size
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundRepeat = 'no-repeat';
  container.style.backgroundColor = 'var(--gradient-background)';
  container.style.zIndex = '1000';
  container.style.pointerEvents = 'none';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  if (loadingSpinner) {
    loadingSpinner.classList.toggle('hidden');
  }
}

function moveWithHover(image, event, zoomRatio, overlay) {
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio, overlay);
  overlay.onclick = () => overlay.remove();
  overlay.onmouseleave = () => overlay.remove();
  return overlay;
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  
  images.forEach((image) => {
    let overlay = null;

    image.onclick = (event) => {
      if (overlay) {
        overlay.remove();
        overlay = null; // Reset overlay reference for the next click
      } else {
        overlay = magnify(image, zoomRatio);
        image.addEventListener('mousemove', (event) => moveWithHover(image, event, zoomRatio, overlay));
      }
    };
  });
}

enableZoomOnHover(2);
